function convertAcreToHectare(num) {
  let eq =
    "Converting " +
    num +
    " acre to hectare: \n" +
    num +
    " * 0.4046856422 = ";
  let rep = num * 0.4046856422;
  return eq + rep.toFixed(3);
}

function convertAcreToSquareFoot(num) {
  let eq =
    "Converting " + num + " acre to square foot: \n" + num + " * 43560 = ";
  let rep = num * 43560;
  return eq + rep.toFixed(2);
}

function convertAcreToSquareInch(num) {
  let eq =
    "Converting " +
    num +
    " acre to square inch: \n" +
    num +
    " * 6272640 = ";
  let rep = num * 6272640;
  return eq + rep.toFixed(2);
}

function convertAcreToSquareMeter(num) {
  let eq =
    "Converting " +
    num +
    " acre to square meter: \n" +
    num +
    " * 4046.856422 = ";
  let rep = num * 4046.856422;
  return eq + rep.toFixed(3);
}

function convertAcreToSquareMile(num) {
  let eq =
    "Converting " +
    num +
    " acre to square mile: \n" +
    num +
    " * 0.0015625 = ";
  let rep = num * 0.0015625;
  return eq + rep.toFixed(5);
}

function convertAcreToSquareYard(num) {
  let eq =
    "Converting " +
    num +
    " acre to square yard: \n" +
    num +
    " * 4840 = ";
  let rep = num * 4840;
  return eq + rep.toFixed(2);
}

export {
  convertAcreToHectare,
  convertAcreToSquareFoot,
  convertAcreToSquareInch,
  convertAcreToSquareMeter,
  convertAcreToSquareMile,
  convertAcreToSquareYard
};
